<img style="width: 22px; height: 22px; position: absolute; top: 20px; left: 20px;" (click)="this.back()" src="/assets/images/shared/back.svg">
<div style="height: 100vh; width: 100vw; display: flex; justify-content: center; align-items: center;" >
    <div style="text-align: center;"> 
        <img src="/assets/images/invites/image-invite-earn.png" alt="" style="height: 120px; width: 120px; margin-bottom: 10px;"> <br>
        <p style="font-weight: bold;">Покани и спечели</p>
        <p style="color: #ADAFBB; width: 70%; text-align: center; margin: auto;">Покани трима приятели за да получиш ваучер на стойност 5 лв. Покани фирма и получи ваучер на стойност 20 лв!</p>
    </div>
</div>
<div style="position: fixed; bottom: 5px; text-align: center; width: 90%; margin: auto; left: 5%;">
    <div class="row justify-content-around">
        <button type="button" class="btn btn-primary col-5" style="width: 90%; margin: auto; background-color: #E4F2FE; color: #0A69EB;" (click)="this.inviteFirm()"> Покани фирма </button>
        <button type="button" class="btn btn-primary col-5" style="width: 90%; margin: auto;" (click)="this.inviteFriends()"> Покани приятели </button>

    </div>
</div>
